var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 6.5L10 11l8.6-4.5",
    stroke: "#90939E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4v12h18V4H1zm17 11H2V5h16v10z",
    fill: "#90939E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xLjM5OTkgNi41TDkuOTk5OSAxMUwxOC41OTk5IDYuNSIgc3Ryb2tlPSIjOTA5MzlFIi8+CiAgICA8cGF0aCBkPSJNMSA0VjE2SDE5VjRIMVpNMTggMTVIMlY1SDE4VjE1WiIgZmlsbD0iIzkwOTM5RSIvPgo8L3N2Zz4K";
export { SvgEmailIcon as ReactComponent };